module.exports = function getResource(label, vars = []) {
    let resources = {
        requiredInformationLabel: '* Required Information',
        recognizedRegisteredEmailMessage: 'We think you already registered for Beauty Insider in a Sephora store because we recognize your email address',
        fillInformationMessage: 'Please fill out the information below to complete your profile.',
        notYouMessage: 'Not you? To clear the registration information and start over',
        notYouClickHereClearLink: 'click here',
        firstNameLabel: 'First name',
        lastNameLabel: 'Last name',
        emailAddresLabel: 'Email address',
        passwordLabel: `Password (${vars[0]} to ${vars[1]} characters)`,
        showPasswordLinkAriaLabel: 'Show password text',
        hidePasswordLinkAriaLabel: 'Hide password text',
        phoneNumber: 'Phone number (optional)',
        staySignedInLabel: 'Keep me signed in',
        joinSephoraLabel: 'Join Sephora Beauty Insider',
        joinSephoraDisclaimer: 'By joining our Beauty insider program, you will earn points on every purchase.',
        zipCodeLabel: 'ZIP Code (to hear about store events near you)',
        createAccountButtonLabel: 'Create Account',
        registerButtonLabel: 'Register',
        joinNow: 'Join Now',
        joinTheBILabel: 'Join the Beauty Insider loyalty program. Earn points, redeem rewards, and more.',
        useYourPhoneLabel: 'Use your phone number for faster account lookup in store. Already gave us a phone number in store? Enter it here to merge your accounts.',
        staySignedInTooltip: 'Selecting this option means you won’t have to sign in as often on this device. For your security, we recommend only doing this on your personal devices.',
        gotIt: 'Got It',
        infoIcon: 'info icon',
        continue: 'Continue',
        registrationComplete: 'Registration Complete',
        confirmMessageBI: 'Congratulations! You are now a Beauty Insider',
        confirmMessage: 'Thank you for registering with Sephora'

    };

    return resources[label];
};
